import { ReactNode } from "react";

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  return <div className="container mx-auto px-4 py-8">{children}</div>;
};
